import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-medium);

	.motif-accordion-title-content {
		flex: 1;
	}
	.motif-accordion-content {
		--accordion-padding-v: var(--spacing-large);
		--accordion-padding-h: var(--spacing-xx-large);
		padding: 0;
	}
`;
